"use strict";

/**
 * @classdesc
 * Aktion zum leeren des Logbuchs.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.module.GCErrorConsole
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {gc.gis.module.GCErrorConsole} options.instance Modulinstanz
 */
gc.gis.module.GCErrorConsole.ClearAction = function( options )
{
    gc.gis.action.GCAbstractAction.call( this, options );

    var self = this;

    this.module = options.instance;
    this.active = true;

    this.func = function()
    {
        gc.gis.iface.log.clear();
    };
    this.args = [];
};
gc.gis.module.GCErrorConsole.ClearAction.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );
